<template>
    <vue-final-modal v-model="showModal">
        <section class="col join-community-popup mfp-hide mt-5 wrap-popup" style="z-index: 9999;">
            <div class="join-community-wrapper">
                <div class="save-document-form">
                    <h2>Analyst Hub Community</h2>
                    <p>Share, connect, discuss, learn from others and much more…</p>
                </div>
                <div class="join-community-text">
                    <p>Here you can find documents and templates shared by all the Analyst Hub users.
                        Feel free to engage, comment, ask questions and add docuements you like to your favourites.</p>
                    <p>If you see something thatcould be perfect for your next project, be our guest and use one of these community documents as a starting point for your own craft.</p>
                    <a href="javascript:;" @click="joinCommunity()" class="btn btn-primary">Join the Community</a>
                </div>
            </div>
        </section>
    </vue-final-modal>
</template>

<script>
import ApiService from "../api/api.service";
window.Vue = require('vue');
import { VueFinalModal } from 'vue-final-modal/lib'


export default {
    name: "CommunityJoin",
    data: () => {
        return {
            showModal: false,
        } ;
    },
    components: {
        VueFinalModal
    },
    mounted() {
        if(this.$route.path == '/community/join') {
            this.showModal = true;
        }
    },
    methods: {
        joinCommunity() {
            ApiService.setHeader();
            ApiService.post('/api/community/join')
                .then((res) => {

                    let user = localStorage.getItem('user');
                    let userObj = JSON.parse(user);
                    userObj.community_member = true;
                    localStorage.setItem('user', JSON.stringify(userObj));

                    this.$router.push('/community');
                    this.showModal = false;

                })
                .catch((res) => {
                    console.log(res);
                });
        }
    }
}
</script>

<style scoped>

@media screen and (min-width: 1024px) {
    .wrap-popup {
        width: calc(100% - 286px);
        margin-left: calc(50% - 286px);
    }
}

@media screen and (max-width: 1024px)
            and (min-width: 769px) {
    .wrap-popup {
        width: calc(100% - 345px);
        margin-left: calc(50% - 195px);
    }
}
@media screen and (max-width: 768px)
            and (min-width: 426px) {
    .wrap-popup {
        width: calc(100% - 286px);
        margin-left: calc(50% - 195px);
    }
}


.setting-profile-wrapper {
    margin-top: 40%;
}
</style>
